import {
    isWatermarkChangeIntentionalMessage,
    singleWatermarkEdit
} from '../components/watermark-change-warning-chip/watermark-warning-constants';

export const backfillWatermarkHelp = `Watermark value for a backfill load`;
export const backFillMinHelp = `The lowest value to retrieve (e.g. pull back until 2010 but not 2001)`;
export const watermarkKeyHelp = `Key to be used as a watermark column for incremental and backfill loads`;
export const watermarkValueHelp = `Value to be used as a watermark column for incremental loads`;
export const watermarkKeyDatatypeHelp = `The datatype of the source column used for the watermark key.`;
export const watermarkOrBackfillValueHelp = 'Value to be used for either backfill or incremental loads. ';
export const cdcTableHelp = `The table holding the change data capture information`;
export const cdcSchemaHelp = `The schema where the change data capture table resides`;
export const scheduleHelp = `Assign a repeating schedule to this job.`;
export const customClusterHelp = `Optional. If specified, the named cluster will be used instead of the default cluster. This can be useful
    when the named cluster has needed libraries, features, or performance characteristics that the default
    cluster does not have.`;
export const customNotebookHelp = `Optional. If specified, this notebook will be run instead of the standard 'inbox_event' notebook, and the path parameter will be sent.`;
export const customExtractorNotebookHelp = `A custom notebook that is executed during the extraction phase of the job loading process. It can be used to execute any custom logic not necessarily extraction logic.`;
export const dateTimeFormatHelp = `The default datetime format of the source. If supplied the Data Ingest Engine will use that format when comparing datetime columns when querying the source. Example: %Y-%m-%dT%H:%M:%S.%9fZ`;
export const copyNullWatermarkValueHelp = `Whether to additionally query all rows where the raw_watermark_key is NULL`;
export const bulkScheduleJobsToolTip =
    'Add jobs from selected entities to a recurring schedule. Please select entities with jobs to activate this option.';
export const activeHelp = 'Only active jobs will be run by the system.';
export const priorityHelp =
    'High priority jobs will run before queued jobs or other scheduled jobs without priority. Use conservatively.';
export const useLegacyEngineHelp =
    'If specified, job will run using the older legacy engine instead of IO Engine.  May be required for backfill jobs.';
export const modeHelp =
    'Specify how source data should be loaded. Incremental loads are recommended for large data sets.';

export const tableNameHelp =
    'Name of this table, optionally including the schema name with dot syntax (e.g. "dbo.myTable").';
export const referenceKeysHelp = 'The primary key(s) for this entity.';
export const configureFilesHelp = 'Configure files';
export const configureFileHelp = 'Edit file configuration';
export const trackHistoryHelp =
    '"Yes" if there should be a history table for this entity (Type 2), or "No" if not (Type 1).';
export const notesHelp = 'Place for history, todos, or any other helpful context around this entity.';

export const directoryHelp = 'Directory to scan for source files.';
export const fileSpecHelp =
    'Expression that limits the files in the directory that are considered (e.g. accounts_*.xml).';

export const fileTypeHelp =
    'This will determine how the file is processed. Hover over the file type for more information.';

export const maximumConcurrentConnectionsHelp =
    'The maximum number of concurrent connections established with the source during data transfer.  Currently used by ADF Copy Data only.  This value will override the value set on the source.';

export const ignoreTopRowsHelp = 'The number of rows from the top of the file that should be ignored.';

export const ignoreBottomRowsHelp = 'The number of rows from the bottom of the file that should be ignored.';

export const escapeQualifierHelp =
    "The character used as an escape qualifier in a delimited file. If blank, '' will be used.";

export const textQualifierHelp =
    'The character used as a text qualifier in a delimited file. If blank, double quotes will be used.';
export const columnDeliminitorHelp = 'Delimiter character or string for text files.';

export const disabledBulkEditJobFieldsDueToMultipleJobsHelp =
    'Cannot edit this property because one or more selected entities have multiple jobs';
export const disabledBulkEditJobFieldsDueToNoJobsHelp =
    'Cannot edit this property because none of the selected entities have jobs.';
export const disabledBulkEditWatermarkValueHelp =
    'Cannot edit this property for an entity ingestion that already exists';

export const existingSchedHelp = 'Use an existing job schedule.';
export const newSchedHelp = 'Create a new job schedule.';

export const referenceKeysUpdatedHelp =
    "You are changing entity reference keys. If data has already been loaded you'll need to consider a redeploy of the entity and a fresh data reload to avoid future loading complications. Contact your system administrator for help with this.";
export const columnConfigUpdatedHelp =
    "You are changing column configuration for a file entity. If data has already been loaded you'll need to consider a redeploy of the entity and a fresh data reload to avoid future loading complications. Contact your system administrator for help with this.";
export const disabledUnsupportedSourceTypes = 'Disabled for unsupported source types.';
export const bulkEditAllSourceEntities = "Edit all this source's entities in a data grid";
export const bulkAddSourceEntities = 'Add multiple entities via an editable data grid';
export const editCommonPropsMessage = 'Apply changes to common properties on multiple entities at once';
export const bulkEditMessage = 'Configure entities in an editable data grid';
export const editSourceMessage = 'Edit this source';
export const duplicateEntitiesMessage = 'Duplicate selected entities and their jobs';
export const deleteSelectedEntitiesMessage = 'Remove the selected entities and their jobs';
export const bulkEditNotesMessage =
    'To clear out notes for all entities, leave this field empty with the notes checkbox selected.';
export const duplicateEntity =
    "Copy entity configuration within this source, without ingestion jobs. You'll be able to edit config details before saving.";
export const duplicateEntityWithJobs =
    "Copy entity configuration within this source, with ingestion jobs. You'll be able to edit config details before saving.";

export const queueJobs =
    'Add jobs to the orchestration pipeline to be run on the next cycle (typically every 15 minutes)';

export const noActiveJobs = 'This schedule has no active jobs';

export const scheduleNoActiveJobs = 'No active jobs are selected';

export const queueActiveJobsForSchedule =
    'Add all active jobs to the orchestration pipeline to be run on the next cycle (typically every 15 minutes)';

export const queueSingleActiveJob =
    'Add job to the orchestration pipeline to be run on the next cycle (typically every 15 minutes)';

export const inactiveJob = 'This ingestion job is currently inactive';

export const smallBatchSizeWarning = 'A batch size of less than 10,000,000 is not recommended';

export const watermarkChangeWarning = `${singleWatermarkEdit} ${isWatermarkChangeIntentionalMessage}`;

export const jobsDeleteWarning =
    'Associated jobs will be deleted, and no longer associated with any schedules. Any queued jobs will still be processed.';

export const entityNameHelp = 'Enter the destination entity name. All ingested files data will land in this entity.';

export const missingRefKeysWarning =
    'No Reference Keys provided. This could affect performance and the success of some ingestion jobs.';

export const refKeysRequiredMessage = 'Ref keys are required for this type';
export const bulkRefKeyRequiredMessage = 'This field is required for the selected ingest mode.';
export const filePatternHelp =
    'Enter the general file name pattern with extension. The filename evaluator will strip off the file extension and use a "starts with" matching strategy, so "my_file_text" will match "my_file[any characters].txt."';

export const tenantInactiveInfo =
    'This tenant is currently set to inactive status. Configuration changes can still be made, but jobs will not run or be returned via the API.';

export const columnDelimiter = 'Delimiter character or string for text files';

export const hasHeader =
    '"Yes" if the entity already contains a header row with column names, ' +
    'or "No" if no header row exists and column names can be optionally specified.';

export const devStatusDevTooltip = 'Use this status for initial development';
export const devStatusQATooltip = 'Use this status during testing';
export const devStatusProdTooltip = 'Use this status when the source is ready for production use';
export const devStatusInactiveTooltip = 'Use this status when the source is no longer in active use or development';
export const devStatusStaticTooltip =
    'Use this status for limited use jobs that do not follow a normal Development, QA, Production life cycle';
export const devStatusDeprecatedTooltip = 'Use this status for sources / entities that should no longer be used';

export const promoterTypeToolTip =
    'Changes from Legacy to Promoter v2 require an entity migration job to be run prior to loading using Promoter v2';
export const promoterTypeWarning =
    'Entities switching from Legacy to Promoter v2 require an entity migration job prior to changing.  Please ensure readiness to run a migration job before changing this value.';

// app & category management modals
export const appNameHelp = 'The name of the application. This will be shown as the header on the application card.';
export const appActiveHelp = 'Inactive applications will not be shown in the application catalog.';
export const appProvidedByHelp =
    'Optional. The name of the organization, owner, or parent app that provides this application. Will be displayed as a subtitle, i.e. "by Health Catalyst".';
export const appDescriptionHelp = 'A brief description of the application. This will be shown on the application card.';
export const appUrlHelp =
    'Optional. The URL to the application. This will be used to launch the application, or link to additional information, etc. If a link is not provided, the primary link button will be disabled.';
export const appActionHelp =
    'The label for the primary action button. Suggested options include "Launch" and "Learn More" and "Coming Soon", but you can create your own label.';
export const appDocsHelp = 'Optional. A URL to documentation or other information about the application.';
export const appCommunityHelp = 'Optional. A URL to a community or forum for the application.';
export const appCategoryHelp =
    'Optional. The category that the application belongs to. This will be used to filter and group applications.';
export const appIconHelp =
    'Optional. An icon to represent the application. This will be shown on the application card. Can choose from our provided icons or upload something custom. Defaults to using the application name initials.';
export const appPrimaryLinkHelp =
    'Primary link the application. This can be a link to application, or if the app is not yet available, a link to documentation or marketing materials';
export const appLinkTextHelp =
    'This will be the label for the primary button on the application card. Can enter a custom label if needed.';
export const appLinkUrlHelp =
    'Optional. This can be a relative URL (e.g. /app/my-app) or an external URL (e.g. https://myapp.com). For Databricks URLs, login_hint is applied automatically at launch using the current user.';
export const catAppsHelp = 'Choose & order the applications that belong to this category.';
export const catNameHelp = 'Choose a descriptive name for the application category.';
export const catActiveHelp =
    'Inactive categories (and apps assigned to them) will not be shown in the application catalog.';
export const catDescriptionHelp = 'A brief description of the application category.';

// contact management modal
export const contactNameHelp = 'The name of an individual or group that can be contacted for support or questions.';
export const contactActiveHelp = 'Inactive contacts will not be shown in the contact list.';
export const contactEmailHelp = 'The email address for the contact.';
export const contactTitleHelp = 'The title or role of the contact. Example: "HCAT Analytics Director';
export const contactCompanyHelp =
    'The name of the company for this contact. Examples: "HCAT", "Health Catalyst", "XYZ Corp"';

// Admin/Access Management
export const addAssignmentOnSave = 'This user will be added when you save';
export const removeAssignmentOnSave = 'This user will be removed when you save';
export const removeAccess = 'Remove access';
export const undoRemoveAccess = 'Undo (user will no longer be marked for removal)';
export const subjectIdHelp = 'Add users and groups';
export const bulkAssignRoles = 'Assign multiple users and groups to multiple roles';
export const bulkRemoveRoles = 'Remove multiple users and groups from multiple roles';
export const dataEntryAdminTabHelp = 'Manage access to features within Ignite Data Entry';
export const uiAccessAdminTabHelp = 'Manage access to features within the Ignite web application';
export const dataEntryPermissions =
    'Use this page to grant access to applications within the Data Entry module of Ignite UI only.  To request access to Data Entry catalog data in Databricks, please work with your Tenant Manager or data access manager.';
export const dataEntryAppPermissions =
    'Use this page to grant access to this application within the Data Entry module of Ignite UI only.  To request access to Data Entry catalog data in Databricks, please work with your Tenant Manager or data access manager.';

// Tenant fields
export const tenantNameHelp = "The organization's name.";
export const tenantCodeHelp = 'A unique code, 4-to-5 characters.';
export const tenantLocationHelp = 'The Azure region the tenant will reside within.';
export const tenantActiveHelp = 'Set whether this tenant is active.';
